import store from '../store/premiumFlightStore';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('persistFlight', function persistFlight(flightName: string) {
    store.flightNames.push(flightName.toLowerCase());
});
